import React, { useEffect, useState } from 'react'
import Dashboardheader from './Dashboardcomponents/Dashboardheader'
import styles from "./Dashboard.module.css"
import Environmentpanel from './Dashboardcomponents/Environmentpanel'
import { Outlet, useParams, useLocation, useNavigate } from 'react-router-dom'
import { get_all_project_Api } from '../dashboardapi';
import { useToast } from "@chakra-ui/react";

const Dashboard = () => {
    const [token, setToken] = useState("");
    const [projects, setProjects] = useState([]);
    const { project } = useParams();
    const location = useLocation();
    const toast = useToast();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state?.toastMessage) {
            setTimeout(() => {
                toast({
                    title: "Invalid Project",
                    description: location.state.toastMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: false,
                });
            }, 500);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state,toast]);


    useEffect(() => {
        let token = localStorage.getItem("token")
        setToken(token)
    }, []);

    return (
        <div className={styles.dashboard_outer}>
            <div className={styles.dashboard_head}>
                <Dashboardheader />
            </div>
            <div className={styles.environment_panel}>
                <Environmentpanel />
            </div>
            <div className={styles.project_display}>
                <Outlet />
            </div>
        </div>
    )
}

export default Dashboard